export default __webpack_public_path__ + "static/media/Bangle of the Ghost of the Veldt.34092786.jpg";